import { form } from '../formState'
import { FormProps as Props } from '../typings'

import { CustomFields } from './CustomFields'
import { DynamicLoads } from './DynamicLoads'
import { ExecutionEvents } from './ExecutionEvents'
import { Pods } from './Pods'

export function Form(props: Props) {
  const {
    territory: { enableDynamicLoads, enableDynamicCustomFields },
  } = props

  const values = form.useForm().values

  return (
    <>
      <ExecutionEvents {...props} values={values} />
      {enableDynamicLoads && <DynamicLoads {...props} />}
      {enableDynamicCustomFields && <CustomFields {...props} />}
      <Pods {...props} values={values} />
    </>
  )
}
